import ErrorMessage from '@components/atoms/ErrorMessage';
import BREAKPOINTS from '@lib/constants/breakpoints';
import COLORS from '@lib/constants/colors';
import { trackEvent } from '@lib/services/analytics';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  height: auto;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  label {
    margin: 0 0 16px 0;
    width: 400px;
    min-height: 60px;

    overflow: hidden;
    display: inline-block;
    cursor: pointer;
    position: relative;
    user-select: none;
    transition: border-color 0.1s;

    @media screen and (max-width: ${BREAKPOINTS.medium}) {
      width: 100%;
    }
  }

  input[type='radio'] {
    position: absolute;
    opacity: 0;
    top: -20px;
    left: -20px;

    vertical-align: text-bottom;
  }

  input[type='radio']:checked + .option-inner {
    background-color: rgb(247, 247, 247);
    border: 1px solid ${COLORS.black};
  }

  .option-inner {
    padding: 15px 15px 15px 10px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(221, 221, 221);
    outline: 0;
    font-size: 100%;
    vertical-align: baseline;
    border-radius: 12px;

    transition: all 0.3s ease-in-out;

    p {
      text-align: left;
      padding: 0 10px 0 10px;
    }
  }
`;

const RadioGroup = ({
  name,
  options,
  inputRef,
  onSelected,
  errorMessage,
}: {
  name: string;
  inputRef?: React.Ref<HTMLInputElement>;
  options: {
    value: string | number;
    label: React.ReactNode;
    checked?: boolean;
    example?: string;
  }[];
  onSelected?: (value: string | number) => void;
  errorMessage?: string;
}) => (
  <Wrapper>
    {options.map((option) => (
      <label htmlFor={`radio-id-${option.value}`} key={option.value}>
        <input
          id={`radio-id-${option.value}`}
          type="radio"
          name={name}
          ref={inputRef}
          value={option.value}
          defaultChecked={option.checked}
          onClick={(e) => {
            trackEvent('choosed item on radio group', {
              ...option,
              inputName: name,
            });
            if (onSelected && e.currentTarget.checked) {
              onSelected(option.value);
            }
          }}
        />

        <div className="option-inner">
          <div>
            <p style={{fontWeight:'normal'}}>{option.label}</p>
            {option.example && (
              <p style={{ fontSize: 14, color: COLORS.gray, marginTop:4 }}>
                {option.example}
              </p>
            )}
          </div>
          <i />
        </div>
      </label>
    ))}
    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
  </Wrapper>
);

export default RadioGroup;
